var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermicIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 128.6",
    style: {
      enableBackground: "new 0 0 120.2 128.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#424242;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.9,78V44.1c0-2.5-2-4.4-4.5-4.4c-2.5,0-4.5,2-4.5,4.4V78c-4.1,1-7.7,3.4-10.3,6.8 c-2.9,3.9-4.2,8.7-3.5,13.6c1.3,9,9.1,15.7,18.2,15.7c0,0,0.1,0,0.1,0c10.1,0,18.3-8.2,18.4-18.3C89.9,87.4,84,80,75.9,78z  M71.4,105.2c-5.2,0-9.5-4.2-9.5-9.4c0-5.2,4.3-9.4,9.5-9.4c5.2,0,9.5,4.2,9.5,9.4C80.9,100.9,76.6,105.2,71.4,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.7,53.8H102c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h14.7c1.9,0,3.5-1.6,3.5-3.5S118.6,53.8,116.7,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.1,25.5h8.6c1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5h-8.6c-1.9,0-3.5,1.6-3.5,3.5S103.2,25.5,105.1,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102,37.2h14.7c1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5H102c-1.9,0-3.5,1.6-3.5,3.5S100.1,37.2,102,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.8,42h-8.6c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h8.6c1.9,0,3.5-1.6,3.5-3.5S115.7,42,113.8,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.2,77.7c-5.3-0.7-7.8-7.1-8.2-9.6c-0.4-1.9-2.2-3.1-4.1-2.7c-1.9,0.4-3.1,2.2-2.7,4.1 c1,4.7,5.2,14,14.2,15.1c0.1,0,0.3,0,0.4,0c1.7,0,3.2-1.3,3.5-3.1C33.5,79.7,32.1,78,30.2,77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.3,70V17.9C89.3,8,81.2,0,71.3,0c-9.9,0-18,8-18,17.9v21.9c-3.2-4.6-6.6-9-10.2-13.1 c-2.5-2.8-4.8-5.8-7.4-8.4l-0.2-0.2c-1.6-1.5-4.4-1.4-5.9,0.2c-0.3,0.3-7.8,8.1-15.1,17.9c-4.2,5.6-7.5,10.7-9.9,15.4 C1.6,57.6,0,62.8,0,67.1c0,18.6,14.7,33.7,32.7,33.7c2.3,0,4.6-0.3,6.8-0.8c0.5,4.9,2,9.6,4.7,13.9c5.9,9.3,16,14.8,26.8,14.8h0 l0.3,0h0.1c8.6,0,16.7-3.4,22.7-9.4c6.1-6.1,9.4-14.1,9.4-22.7C103.5,85.8,98.2,76,89.3,70z M39.9,89.7c-0.1,0.4-0.1,0.8-0.1,1.2 c-2.2,0.8-4.6,1.2-7.1,1.2c-13.3,0-24.1-11.2-24.1-25.1c0-2.7,1.1-6.3,3.2-10.6c1.9-3.7,4.5-8,7.8-12.6c4.8-6.6,9.9-12.6,13.1-16.1 c2.7,3.1,7.1,8.4,9.5,11.3c4.9,6.3,8.6,11.9,11.1,16.8c0,0.1,0.1,0.2,0.1,0.3V70C46.5,74.6,41.7,81.6,39.9,89.7z M92.8,108.9 c-6.8,11.7-21.9,15.8-33.7,9c-5.7-3.3-9.8-8.6-11.5-14.9c-1.7-6.3-0.8-12.9,2.5-18.6c2.2-3.7,5.3-6.8,9-9c1.2-0.7,1.9-1.9,1.9-3.3 V17.9c0-5.7,4.7-10.4,10.4-10.4c5.8,0,10.5,4.7,10.5,10.4v54.1c0,1.3,0.7,2.6,1.9,3.3c5.7,3.3,9.8,8.6,11.5,14.9 C96.9,96.6,96.1,103.2,92.8,108.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermicIndicator);
export default __webpack_public_path__ + "static/media/TermicIndicator.a10a80650cad96976af89f5379525e2a.svg";
export { ForwardRef as ReactComponent };